/* eslint-disable prettier/prettier */ 
"use strict";
class $a5fd07fa01589658$export$2e2bcd8739ae039 {
    /**
   * Creates a new game instance.
   *
   * @param {number[][]} initialState
   * The initial state of the board.
   * @default
   * [[0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0]]
   *
   * If passed, the board will be initialized with the provided
   * initial state.
   */ constructor(initialState = [
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ]
    ]){
        this.initialState = initialState;
        this.gameScore = 0;
        this.state = [
            ...this.initialState
        ];
        this.size = 4; // The size of the board (4x4)
        this.lastGameScore = 2048; // The score to win the game
        this.status = "idle";
    }
    start() {
        this.status = "playing";
        this.addCell();
        this.addCell();
    }
    restart() {
        this.status = "idle";
        this.state = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.gameScore = 0;
    }
    getScore() {
        return this.gameScore;
    }
    getState() {
        return this.state;
    }
    getStatus() {
        return this.status;
    }
    moveLeft() {
        let canMove = false;
        const newState = [];
        for(let i = 3; i >= 0; i--){
            const row = this.state[i].filter((number)=>number !== 0);
            for(let n = 1; n < row.length; n++)if (row[n] === row[n - 1]) {
                row[n - 1] *= 2;
                delete row[n];
                this.gameScore += row[n - 1];
            }
            const newRow = row.filter((number)=>number !== undefined);
            for(let j = newRow.length; j < this.size; j++)newRow.push(0);
            newState[i] = newRow;
        }
        for(let i = 0; i <= this.size - 1; i++){
            for(let n = 0; n <= this.size - 1; n++)if (newState[i][n] !== this.state[i][n]) canMove = true;
        }
        if (canMove) {
            this.state = newState;
            this.addCell();
        }
        this.isLose();
        this.isWin();
    }
    moveRight() {
        const newState = [];
        let canMove = false;
        for(let i = 3; i >= 0; i--){
            const row = this.state[i].filter((number)=>number !== 0);
            for(let n = row.length - 1; n >= 0; n--)if (row[n] === row[n - 1]) {
                row[n] *= 2;
                row[n - 1] = 0;
                this.gameScore += row[n];
            }
            const newRow = row.filter((number)=>number !== 0);
            for(let j = newRow.length; j < this.size; j++)newRow.unshift(0);
            newState[i] = newRow;
        }
        for(let i = 0; i <= 3; i++){
            for(let n = 0; n <= 3; n++)if (newState[i][n] !== this.state[i][n]) canMove = true;
        }
        if (canMove) {
            this.state = newState;
            this.addCell();
        }
        this.isLose();
        this.isWin();
    }
    moveUp() {
        this.state = this.updateState(this.state);
        this.moveLeft();
        this.state = this.updateState(this.state);
    }
    moveDown() {
        this.state = this.updateState(this.state);
        this.moveRight();
        this.state = this.updateState(this.state);
    }
    addCell() {
        const initial = Math.random() > 0.1 ? 2 : 4;
        let count = 0;
        do {
            const row = Math.round(Math.random() * 3);
            const column = Math.round(Math.random() * 3);
            if (this.state[row][column] === 0) {
                this.state[row][column] = initial;
                count++;
            }
        }while (count < 1);
    }
    updateState(state) {
        const newState = [];
        for(let i = 0; i <= this.size - 1; i++)newState.push([
            state[0][i],
            state[1][i],
            state[2][i],
            state[3][i]
        ]);
        return newState;
    }
    isWin() {
        for(let i = 0; i <= this.size - 1; i++){
            for(let n = 0; n <= this.size - 1; n++)if (this.state[i][n] === this.lastGameScore) this.status = "win";
        }
    }
    isLose() {
        for(let i = 0; i < this.size; i++)for(let j = 0; j < this.size; j++){
            if (this.state[i][j] === 0) return;
            if (i < 3 && this.state[i][j] === this.state[i + 1][j] || j < 3 && this.state[i][j] === this.state[i][j + 1]) return;
        }
        this.status = "lose";
    }
}


'use strict';
const $09e991522ca7e64e$var$BOARD_SIZE = 4; // Size of the game board
const $09e991522ca7e64e$var$game = new (0, $a5fd07fa01589658$export$2e2bcd8739ae039)();
const $09e991522ca7e64e$var$controls = document.querySelector('.controls');
const $09e991522ca7e64e$var$gameScore = document.querySelector('.game-score');
const $09e991522ca7e64e$var$tbody = document.querySelector('tbody');
const $09e991522ca7e64e$var$messageStart = document.querySelector('.message-start');
const $09e991522ca7e64e$var$messageLose = document.querySelector('.message-lose');
const $09e991522ca7e64e$var$messageWin = document.querySelector('.message-win');
const $09e991522ca7e64e$var$buttonRestart = document.createElement('button');
const $09e991522ca7e64e$var$buttonStart = document.querySelector('.start');
$09e991522ca7e64e$var$buttonRestart.classList.add('restart');
$09e991522ca7e64e$var$buttonRestart.classList.add('button');
$09e991522ca7e64e$var$buttonRestart.textContent = 'Restart';
$09e991522ca7e64e$var$buttonStart.addEventListener('click', ()=>{
    $09e991522ca7e64e$var$game.start();
    $09e991522ca7e64e$var$messageStart.classList.add('hidden');
    $09e991522ca7e64e$var$board();
    $09e991522ca7e64e$var$buttonStart.remove();
    $09e991522ca7e64e$var$controls.append($09e991522ca7e64e$var$buttonRestart);
});
$09e991522ca7e64e$var$buttonRestart.addEventListener('click', ()=>{
    $09e991522ca7e64e$var$game.restart();
    $09e991522ca7e64e$var$game.start();
    $09e991522ca7e64e$var$board();
    $09e991522ca7e64e$var$messageWin.classList.add('hidden');
    $09e991522ca7e64e$var$messageLose.classList.add('hidden');
});
document.addEventListener('keydown', (e)=>{
    if ($09e991522ca7e64e$var$game.status !== 'playing') return;
    const oldState = JSON.parse(JSON.stringify($09e991522ca7e64e$var$game.getState()));
    switch(e.key){
        case 'ArrowLeft':
            $09e991522ca7e64e$var$game.moveLeft();
            break;
        case 'ArrowRight':
            $09e991522ca7e64e$var$game.moveRight();
            break;
        case 'ArrowUp':
            $09e991522ca7e64e$var$game.moveUp();
            break;
        case 'ArrowDown':
            $09e991522ca7e64e$var$game.moveDown();
            break;
    }
    if ($09e991522ca7e64e$var$game.status === 'win') $09e991522ca7e64e$var$messageWin.classList.remove('hidden');
    if ($09e991522ca7e64e$var$game.status === 'lose') $09e991522ca7e64e$var$messageLose.classList.remove('hidden');
    if ($09e991522ca7e64e$var$buttonStart) {
        $09e991522ca7e64e$var$buttonStart.remove();
        $09e991522ca7e64e$var$controls.append($09e991522ca7e64e$var$buttonRestart);
    }
    $09e991522ca7e64e$var$board(oldState);
});
const $09e991522ca7e64e$var$board = (oldState)=>{
    $09e991522ca7e64e$var$gameScore.textContent = $09e991522ca7e64e$var$game.getScore();
    const rows = [
        ...$09e991522ca7e64e$var$tbody.querySelectorAll('.field-row')
    ];
    for(let i = 0; i < $09e991522ca7e64e$var$BOARD_SIZE; i++)for(let j = 0; j < $09e991522ca7e64e$var$BOARD_SIZE; j++){
        const cells = [
            ...rows[i].querySelectorAll('.field-cell')
        ];
        const cellValue = $09e991522ca7e64e$var$game.getState()[i][j];
        if (cellValue === 0) {
            cells[j].textContent = '';
            cells[j].className = 'field-cell';
        } else {
            cells[j].textContent = cellValue;
            cells[j].className = 'field-cell';
            cells[j].classList.add('field-cell--' + cellValue);
            if (oldState && cellValue === oldState[i][j] * 2) {
                cells[j].classList.add('tile-merged');
                setTimeout(()=>cells[j].classList.remove('tile-merged'), 200);
            }
        }
    }
};


//# sourceMappingURL=js-2048-game.67de2b35.js.map
